var icon = 'fx_2d2fb1e5_1ydb7j01';

export { icon };
//# sourceMappingURL=icon.vanilla.mjs.map
